(function () {
  'use strict';

  // SpicyWear PDP gallery enhancements (mobile, thumbs-mode galleries).
  // - hide the thumbnail strip
  // - bare side arrows + Skims-style sliding progress bar
  // - bare zoom icon -> full-screen viewer: swipe through photos AND videos,
  //   pinch/pan/double-tap to zoom; videos autoplay (muted/loop) in the viewer too
  // - inline videos autoplay (muted/loop) only while on-screen; zoom hidden on video slides
  // - extra bottom spacing under the gallery (above the star rating)
  //
  // Gallery navigation uses the THEME'S OWN event ('theme:image:change' with a
  // media id) because the theme exposes no Flickity global/instance. No slide
  // sizing/height changes by us.

  var STYLE_ID = 'sw-pdp-gallery-style';

  function injectStyle() {
    if (document.getElementById(STYLE_ID)) return;
    var css = [
      // Layout rules (hide thumbs/dots, bottom spacing) live in layout/theme.liquid <head> so they apply before first paint.
      '@media (max-width:768px){',
      '.sw-gal-ctrl{position:absolute!important;background:transparent!important;border:0!important;outline:0!important;box-shadow:none!important;padding:0!important;margin:0!important;display:flex!important;align-items:center;justify-content:center;cursor:pointer;z-index:20;color:#1b1b1b;-webkit-tap-highlight-color:transparent;}',
      '.sw-gal-ctrl svg{filter:drop-shadow(0 1px 2px rgba(0,0,0,.45));pointer-events:none;}',
      '.sw-gal-arrow{transform:translateY(-50%);width:44px;height:64px;}',
      '.sw-gal-prev{left:4px;}',
      '.sw-gal-next{right:4px;}',
      '.sw-gal-zoom{width:40px;height:40px;}',
      '.sw-gal-bar{position:absolute;left:0;right:0;height:7px;z-index:20;background:rgba(0,0,0,.15);overflow:hidden;pointer-events:none;}',
      '.sw-gal-thumb{height:100%;background:#111;transition:transform .25s ease;}',
      '}',
      '@media (min-width:769px){.sw-gal-ctrl,.sw-gal-bar{display:none!important;}}',
      '.sw-gal-hide{display:none!important;}',
      '.sw-zoom-overlay{position:fixed;inset:0;z-index:99999;background:rgba(0,0,0,.93);display:none;touch-action:none;overscroll-behavior:contain;}',
      '.sw-zoom-overlay.is-open{display:block;}',
      '.sw-zoom-stage{position:absolute;inset:0;overflow:hidden;display:flex;align-items:center;justify-content:center;}',
      '.sw-zoom-img,.sw-zoom-video{max-width:100%;max-height:100%;will-change:transform;transform-origin:center center;-webkit-user-select:none;user-select:none;-webkit-user-drag:none;touch-action:none;}',
      '.sw-zoom-close{position:absolute;top:14px;right:14px;z-index:2;background:transparent;border:0;color:#fff;cursor:pointer;padding:8px;line-height:0;-webkit-tap-highlight-color:transparent;}',
      '.sw-zoom-count{position:absolute;top:18px;left:16px;z-index:2;color:#fff;font-size:13px;letter-spacing:.04em;opacity:.85;}'
    ].join('');
    var s = document.createElement('style');
    s.id = STYLE_ID;
    s.textContent = css;
    document.head.appendChild(s);
  }

  var CHEV_L = '<svg width="28" height="28" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><polyline points="15 18 9 12 15 6"></polyline></svg>';
  var CHEV_R = '<svg width="28" height="28" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><polyline points="9 18 15 12 9 6"></polyline></svg>';
  var MAG = '<svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><circle cx="11" cy="11" r="7"></circle><line x1="20.5" y1="20.5" x2="16.5" y2="16.5"></line><line x1="11" y1="8" x2="11" y2="14"></line><line x1="8" y1="11" x2="14" y2="11"></line></svg>';
  var XICON = '<svg width="30" height="30" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><line x1="18" y1="6" x2="6" y2="18"></line><line x1="6" y1="6" x2="18" y2="18"></line></svg>';

  var zoom = null;
  function buildZoom() {
    if (zoom) return zoom;
    var overlay = document.createElement('div');
    overlay.className = 'sw-zoom-overlay';
    var stage = document.createElement('div');
    stage.className = 'sw-zoom-stage';
    var img = document.createElement('img');
    img.className = 'sw-zoom-img';
    img.alt = '';
    var video = document.createElement('video');
    video.className = 'sw-zoom-video';
    video.setAttribute('playsinline', '');
    video.setAttribute('muted', '');
    video.loop = true; video.muted = true;
    video.style.display = 'none';
    var close = document.createElement('button');
    close.type = 'button';
    close.className = 'sw-zoom-close';
    close.setAttribute('aria-label', 'Close zoom');
    close.innerHTML = XICON;
    var count = document.createElement('div');
    count.className = 'sw-zoom-count';
    stage.appendChild(img);
    stage.appendChild(video);
    overlay.appendChild(stage);
    overlay.appendChild(close);
    overlay.appendChild(count);
    document.body.appendChild(overlay);

    var items = [], idx = 0, onChange = function () {};
    var scale = 1, tx = 0, ty = 0;
    var mediaEl = img;

    function applyTo(el) { el.style.transform = 'translate(' + tx + 'px,' + ty + 'px) scale(' + scale + ')'; }
    function apply() { applyTo(mediaEl); }
    function clampPan() {
      var ow = (mediaEl.clientWidth * scale - window.innerWidth) / 2;
      var oh = (mediaEl.clientHeight * scale - window.innerHeight) / 2;
      var maxX = ow > 0 ? ow : 0;
      var maxY = oh > 0 ? oh : 0;
      if (tx > maxX) tx = maxX; if (tx < -maxX) tx = -maxX;
      if (ty > maxY) ty = maxY; if (ty < -maxY) ty = -maxY;
    }
    function updateCount() { count.textContent = items.length > 1 ? (idx + 1) + ' / ' + items.length : ''; }

    function playZoomVideo() {
      video.muted = true;
      var attempt = function () { try { var p = video.play(); if (p && p.catch) p.catch(function () {}); } catch (e) {} };
      attempt();
      video.addEventListener('canplay', attempt, { once: true });
    }

    function show(i, sync) {
      var n = items.length; if (n < 1) return;
      idx = ((i % n) + n) % n;
      scale = 1; tx = 0; ty = 0;
      var it = items[idx];
      try { video.pause(); } catch (e) {}
      if (it.type === 'video' && it.src) {
        mediaEl = video;
        img.style.display = 'none';
        video.style.display = '';
        if (it.poster) video.setAttribute('poster', it.poster);
        if (video.src !== it.src) video.src = it.src;
        video.muted = true; video.loop = true;
        video.style.transition = 'none';
        applyTo(video);
        playZoomVideo();
      } else {
        mediaEl = img;
        video.style.display = 'none';
        try { video.removeAttribute('src'); video.load(); } catch (e) {}
        img.style.display = '';
        img.style.transition = 'none';
        img.src = it.src;
        applyTo(img);
      }
      updateCount();
      if (sync) onChange(it.id);
    }
    function snapBack() {
      tx = 0; ty = 0;
      mediaEl.style.transition = 'transform .2s ease';
      apply();
      setTimeout(function () { mediaEl.style.transition = 'none'; }, 220);
    }

    function open(opts) {
      items = opts.items || [];
      onChange = opts.onChange || function () {};
      show(opts.index || 0, false);
      overlay.classList.add('is-open');
      document.documentElement.style.overflow = 'hidden';
      document.body.style.overflow = 'hidden';
    }
    function doClose() {
      try { video.pause(); } catch (e) {}
      overlay.classList.remove('is-open');
      document.documentElement.style.overflow = '';
      document.body.style.overflow = '';
    }

    close.addEventListener('click', function (e) { e.stopPropagation(); doClose(); });
    overlay.addEventListener('click', function (e) {
      if (e.target === overlay || e.target === stage) doClose();
    });

    document.addEventListener('keydown', function (e) {
      if (!overlay.classList.contains('is-open')) return;
      if (e.key === 'Escape') doClose();
      else if (e.key === 'ArrowRight') show(idx + 1, true);
      else if (e.key === 'ArrowLeft') show(idx - 1, true);
    });

    var startDist = 0, startScale = 1, startTx = 0, startTy = 0, startX = 0, startY = 0;
    var mode = null;
    var lastTap = 0, lastTapX = 0, lastTapY = 0, moved = false, dragDX = 0, dragDY = 0;
    var SWIPE_MIN = 50;

    function dist(t0, t1) {
      var dx = t0.clientX - t1.clientX, dy = t0.clientY - t1.clientY;
      return Math.sqrt(dx * dx + dy * dy);
    }

    stage.addEventListener('touchstart', function (e) {
      moved = false; dragDX = 0; dragDY = 0;
      mediaEl.style.transition = 'none';
      if (e.touches.length === 2) {
        mode = 'pinch';
        startDist = dist(e.touches[0], e.touches[1]);
        startScale = scale; startTx = tx; startTy = ty;
        e.preventDefault();
      } else if (e.touches.length === 1) {
        startX = e.touches[0].clientX; startY = e.touches[0].clientY;
        if (scale > 1) { mode = 'pan'; startTx = tx; startTy = ty; }
        else { mode = 'swipe'; }
      }
    }, { passive: false });

    stage.addEventListener('touchmove', function (e) {
      if (mode === 'pinch' && e.touches.length === 2) {
        var d = dist(e.touches[0], e.touches[1]);
        scale = startScale * (d / startDist);
        if (scale < 1) scale = 1; if (scale > 4) scale = 4;
        clampPan(); apply(); moved = true; e.preventDefault();
      } else if (mode === 'pan' && e.touches.length === 1) {
        tx = startTx + (e.touches[0].clientX - startX);
        ty = startTy + (e.touches[0].clientY - startY);
        clampPan(); apply(); moved = true; e.preventDefault();
      } else if (mode === 'swipe' && e.touches.length === 1) {
        dragDX = e.touches[0].clientX - startX;
        dragDY = e.touches[0].clientY - startY;
        if (Math.abs(dragDX) > 6) { moved = true; e.preventDefault(); }
        mediaEl.style.transform = 'translate(' + dragDX + 'px,0) scale(1)';
      }
    }, { passive: false });

    stage.addEventListener('touchend', function (e) {
      if (mode === 'pinch' || mode === 'pan') {
        if (scale <= 1.02) { scale = 1; snapBack(); }
      } else if (mode === 'swipe') {
        if (moved && Math.abs(dragDX) > SWIPE_MIN && Math.abs(dragDX) > Math.abs(dragDY)) {
          if (dragDX < 0) show(idx + 1, true); else show(idx - 1, true);
        } else if (!moved && e.changedTouches.length === 1) {
          var now = Date.now(), t = e.changedTouches[0];
          if (now - lastTap < 300 &&
              Math.abs(t.clientX - lastTapX) < 30 && Math.abs(t.clientY - lastTapY) < 30) {
            scale = 2.5;
            tx = (window.innerWidth / 2 - t.clientX) * (scale - 1);
            ty = (window.innerHeight / 2 - t.clientY) * (scale - 1);
            clampPan(); apply(); lastTap = 0;
          } else { lastTap = now; lastTapX = t.clientX; lastTapY = t.clientY; }
        } else {
          snapBack();
        }
      }
      if (e.touches.length === 0) mode = null;
    });

    stage.addEventListener('dblclick', function (e) {
      if (scale === 1) scale = 2.5; else { scale = 1; tx = 0; ty = 0; }
      apply(); e.preventDefault();
    });

    zoom = { open: open, close: doClose };
    return zoom;
  }

  function hiRes(img) {
    var s = (img && (img.currentSrc || img.src)) || '';
    s = s.split('?')[0];
    s = s.replace(/_(\d+)x(\d*)\./, '_1600x.');
    return s;
  }

  function videoSrcOf(v) {
    if (!v) return '';
    var so = v.querySelector('source');
    return v.currentSrc || (so ? so.src : '') || v.src || '';
  }

  function initGallery() {
    injectStyle();
    var ps = document.querySelector('[data-section-type="product"]');
    if (!ps) return;
    var wrap = ps.querySelector('.product__mobile--thumbs');
    var slideshow = ps.querySelector('[data-product-slideshow]');
    if (!wrap || !slideshow) return;
    if (wrap.dataset.swGalControls === '1') return;
    wrap.dataset.swGalControls = '1';

    function visibleSlides() {
      return Array.prototype.filter.call(
        slideshow.querySelectorAll('[data-media-slide]'),
        function (s) { return !s.classList.contains('hide'); }
      );
    }

    function currentMediaId() {
      var t = ps.querySelector('[data-slideshow-thumbnail].is-activated');
      return t ? t.getAttribute('data-media-select') : null;
    }

    function currentIndex(slides) {
      var id = currentMediaId();
      if (id) {
        for (var i = 0; i < slides.length; i++) {
          if (slides[i].getAttribute('data-media-id') === id) return i;
        }
      }
      return 0;
    }

    function navToId(id) {
      slideshow.dispatchEvent(new CustomEvent('theme:image:change', { detail: { id: id } }));
    }

    function isVideoSlide(slide) {
      if (!slide) return false;
      return slide.getAttribute('data-type') !== 'image' || !!slide.querySelector('video,iframe');
    }

    var videoIO = null;
    function setupVideos() {
      var vids = slideshow.querySelectorAll('video');
      var i, v;
      for (i = 0; i < vids.length; i++) {
        v = vids[i];
        v.muted = true; v.loop = true;
        v.setAttribute('muted', '');
        v.setAttribute('playsinline', '');
        v.setAttribute('autoplay', '');
      }
      if (!videoIO && 'IntersectionObserver' in window) {
        videoIO = new IntersectionObserver(function (entries) {
          for (var j = 0; j < entries.length; j++) {
            var en = entries[j], vid = en.target;
            if (en.isIntersecting && en.intersectionRatio >= 0.5) {
              vid.muted = true;
              try { var p = vid.play(); if (p && p.catch) p.catch(function () {}); } catch (e) {}
            } else {
              try { vid.pause(); } catch (e) {}
            }
          }
        }, { threshold: [0, 0.5, 1] });
      }
      if (videoIO) {
        for (i = 0; i < vids.length; i++) {
          if (!vids[i].dataset.swVidObs) { vids[i].dataset.swVidObs = '1'; videoIO.observe(vids[i]); }
        }
      }
    }

    function nav(dir) {
      if (!slideshow.classList.contains('flickity-enabled')) return;
      var slides = visibleSlides();
      var n = slides.length; if (n < 1) return;
      var idx = ((currentIndex(slides) + dir) % n + n) % n;
      var id = slides[idx].getAttribute('data-media-id');
      if (id) navToId(id);
      setTimeout(renderBar, 80);
    }

    function openZoom() {
      var slides = visibleSlides();
      if (!slides.length) return;
      var curId = currentMediaId();
      var items = [];
      for (var i = 0; i < slides.length; i++) {
        var s = slides[i], v = s.querySelector('video');
        if (s.getAttribute('data-type') !== 'image' || v) {
          var vsrc = videoSrcOf(v);
          if (!vsrc) continue;
          items.push({ type: 'video', src: vsrc, poster: v ? v.getAttribute('poster') : '', id: s.getAttribute('data-media-id') });
        } else {
          var im = s.querySelector('img');
          if (!im) continue;
          items.push({ type: 'image', src: hiRes(im), id: s.getAttribute('data-media-id') });
        }
      }
      if (!items.length) return;
      var start = 0;
      for (var k = 0; k < items.length; k++) { if (items[k].id === curId) { start = k; break; } }
      buildZoom().open({ items: items, index: start, onChange: function (id) { navToId(id); } });
    }

    var prev = document.createElement('button');
    prev.type = 'button';
    prev.className = 'sw-gal-ctrl sw-gal-arrow sw-gal-prev';
    prev.setAttribute('aria-label', 'Previous image');
    prev.innerHTML = CHEV_L;

    var next = document.createElement('button');
    next.type = 'button';
    next.className = 'sw-gal-ctrl sw-gal-arrow sw-gal-next';
    next.setAttribute('aria-label', 'Next image');
    next.innerHTML = CHEV_R;

    var zoomBtn = document.createElement('button');
    zoomBtn.type = 'button';
    zoomBtn.className = 'sw-gal-ctrl sw-gal-zoom';
    zoomBtn.setAttribute('aria-label', 'Zoom image');
    zoomBtn.innerHTML = MAG;

    var bar = document.createElement('div');
    bar.className = 'sw-gal-bar';
    var thumb = document.createElement('div');
    thumb.className = 'sw-gal-thumb';
    bar.appendChild(thumb);

    prev.addEventListener('click', function (e) { e.preventDefault(); e.stopPropagation(); nav(-1); });
    next.addEventListener('click', function (e) { e.preventDefault(); e.stopPropagation(); nav(1); });
    zoomBtn.addEventListener('click', function (e) { e.preventDefault(); e.stopPropagation(); openZoom(); });

    wrap.appendChild(prev);
    wrap.appendChild(next);
    wrap.appendChild(zoomBtn);
    wrap.appendChild(bar);

    function placeControls() {
      try {
        var sr = slideshow.getBoundingClientRect();
        var wr = wrap.getBoundingClientRect();
        var top = sr.top - wr.top;
        var center = top + sr.height / 2;
        prev.style.top = center + 'px';
        next.style.top = center + 'px';
        zoomBtn.style.top = (top + sr.height - 50) + 'px';
        zoomBtn.style.right = '10px';
        bar.style.top = (top + sr.height - 7) + 'px';
      } catch (e) {}
    }

    function renderBar() {
      var slides = visibleSlides();
      var n = slides.length || 1;
      var idx = currentIndex(slides);
      thumb.style.width = (100 / n) + '%';
      thumb.style.transform = 'translateX(' + (idx * 100) + '%)';
      zoomBtn.classList.toggle('sw-gal-hide', isVideoSlide(slides[idx]));
      var curVid = slides[idx] ? slides[idx].querySelector('video') : null;
      if (curVid) { curVid.muted = true; try { var pp = curVid.play(); if (pp && pp.catch) pp.catch(function () {}); } catch (e) {} }
      placeControls();
    }

    var rafPending = false;
    var mo = new MutationObserver(function () {
      if (rafPending) return;
      rafPending = true;
      requestAnimationFrame(function () { rafPending = false; renderBar(); });
    });
    try {
      mo.observe(ps, { subtree: true, attributes: true, attributeFilter: ['class'] });
    } catch (e) {}

    setupVideos();
    renderBar();
    setTimeout(function () { setupVideos(); renderBar(); }, 400);
    setTimeout(function () { setupVideos(); renderBar(); }, 1200);
    window.addEventListener('resize', placeControls);
  }

  function boot() { initGallery(); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
  document.addEventListener('shopify:section:load', boot);
})();
